
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agri-input",
      function () {
        return require("private-next-pages/agri-input.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agri-input"])
      });
    }
  